<div class="string1-condition-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow">
            <input matInput formControlName="string1" name="string1" maxlength="255"
                placeholder="{{'string1 ' | translate: ['tmc-yard.entity.transport.masterdata.string1', translationService.language]}}"
                [maxlength]="255">
        </mat-form-field>
    </div>
</div>
